module.exports = __webpack_public_path__ + "img/etc-h5-bg.b40dd485.jpg";